import { useState } from 'react';
import { cn } from '@parrot-software/utils';

import wizardBackgroundJpg from 'images/backgrounds/wizard-bg.jpg';
import wizardBackgroundWebp from 'images/backgrounds/wizard-bg.webp';

// Average colour of the photograph. It fills the panel while the file is still downloading, so the
// fade lands on something close to the final image instead of flashing white.
const PLACEHOLDER_COLOR = '#736d61';

/**
 * Decorative photograph that fills the side panel of the account verification flow.
 *
 * It serves WebP and falls back to JPEG, and it stays invisible until the file has decoded so the
 * panel never shows a half-painted image.
 */
export const WizardBackground = () => {
  const [isLoaded, setIsLoaded] = useState(false);

  return (
    <picture
      className="absolute inset-0 block size-full overflow-hidden"
      style={{ backgroundColor: PLACEHOLDER_COLOR }}
    >
      <source srcSet={wizardBackgroundWebp} type="image/webp" />
      <img
        alt=""
        className={cn('size-full object-cover opacity-0 transition-opacity duration-500', {
          'opacity-100': isLoaded,
        })}
        decoding="async"
        onLoad={() => setIsLoaded(true)}
        src={wizardBackgroundJpg}
      />
    </picture>
  );
};
